import { _js } from '@ifixit/localize';
import { faBold } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const BoldButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBold().run()}
         isActive={editor.isActive('bold')}
         isDisabled={!editor.can().toggleBold()}
         icon={<FontAwesomeIcon icon={faBold} />}
         /* Translators: Bold, as in the text formatting */
         title={_js('Bold')}
         shortcut={'b'}
      />
   );
};
